import React, { useEffect } from "react";
import "../../styles/Notification.css";
import SuccessTick from "../../assets/icons/SuccessTick";
import ErrorIcon from "../../assets/icons/ErrorIcon";
import WarningIcon from "../../assets/icons/WarningIcon";

export type NotificationType = {
  type: "success" | "error" | "info" | "warning";
  message: string;
};

interface NotificationProps extends NotificationType {
  onClose: () => void;
  duration?: number;
}

const Notification: React.FC<NotificationProps> = ({
  type,
  message,
  onClose,
  duration = 3500,
}) => {
  useEffect(() => {
    const timer = setTimeout(onClose, duration);
    return () => clearTimeout(timer);
  }, [onClose, duration]);

  return (
    <div className={`notification notification-${type}`}>
      <span className="notification-icon">
        {type === "success" && <SuccessTick size={24} />}
        {type === "error" && <ErrorIcon size={24} />}
        {type === "warning" && <WarningIcon size={24} />}
      </span>
      <span className="notification-message">{message}</span>
      <button
        className="notification-close"
        onClick={onClose}
        aria-label="Close notification"
      >
        ×
      </button>
    </div>
  );
};

export default Notification;
